export const SLACK_WEBHOOK_URL =
  "https://hooks.slack.com/services/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";
